module.exports = __webpack_public_path__ + "static/img/587.1bb2b0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/rjzz/587.jpg
// module id = f4Aw
// module chunks = 0